export default {
      id: "rotate-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#rotate-left-usage",
      toString: function () {
        return this.url;
      }
    }